import { Duration } from 'date-fns'

import { isServerDateFuture, getDuration } from '../../../../utils/dates'

export function getDistanceToFinish(finishDate: Date): string {
  if (isServerDateFuture(finishDate)) {
    const duration = getDuration(finishDate)

    return transformDurationToString(duration)
  }

  return transformDurationToString(getDuration(new Date()))
}

function transformDurationToString(duration: Omit<Duration, 'years' | 'weeks'>): string {
  return Object.entries(duration)
    .map(([key, value]) => `${value}${map[key as keyof Duration] ?? ':'}`)
    .join('')
}

const map: Partial<Record<keyof Duration, string>> = {
  days: 'D ',
  seconds: '',
}
